import { render, staticRenderFns } from "./OmnichannelProductsList.vue?vue&type=template&id=4c452d92&scoped=true"
import script from "./OmnichannelProductsList.vue?vue&type=script&lang=ts"
export * from "./OmnichannelProductsList.vue?vue&type=script&lang=ts"
import style0 from "./OmnichannelProductsList.vue?vue&type=style&index=0&id=4c452d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c452d92",
  null
  
)

export default component.exports